<template>
  <div>
    <div class="position-relative">
      <div class="container" style="margin-top:20px;">
        <div class="alert alert-default">
          <strong>Informasi!</strong> :
          <ul>
            <li>
              Untuk tahun 2024 wajib pajak di wajibkan untuk login menggunakan <strong>Email / NIK</strong> yang sudah
              terdaftar. Jika
              belum memiliki email terdaftar silahkan registrasi email Anda.
            </li>
            <li>
              Setelah registrasi email silahkan Hubungkan Akun Anda dengan <strong>NPWPD</strong> terdaftar di menu Objek
              Pajak -> <strong>Hubungkan
                NPWPD</strong>
            </li>
            <li>
              Bila Anda tidak mengetahui <strong>NPWPD</strong> Anda, silahkan lihat <strong>SPTPD</strong> terdahulu /
              hubungi Petugas BAPENDA.
            </li>
            <li>
              Gunakan NIB jika Anda adalah Wajib Pajak BADAN.
            </li>
          </ul>
        </div>

        <div class="row">

          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="goSIPP()">
              <card class="border-0 d-flex card-sipp" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object data="/img/svg/9-SIPP.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">SIPP</h6>
              </card>
            </component>
          </div>

          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="goSOP()">
              <card class="border-0 d-flex card-sop" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object data="/img/svg/13-SOP.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">SOP</h6>
              </card>
            </component>
          </div>
          <template v-if="isLogin">
            <!-- <div class="col-md-2 col-sm-12">
              <component :is="'a'" @click="changePassword()">
                <card class="border-0 d-flex card-change-pwd" hover shadow
                  body-classes="text-center align-items-center d-flex justify-content-center">
                  <object type="image" class="text-white card-pajak">
                    <i class="fa fa-lock  mr-2" style="font-size: 100px"></i>
                  </object>
                  <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Ganti Password
                  </h6>
                </card>
              </component>
            </div> -->
            <template v-if="isHasNpwpd">
              <div class="col-md-2 col-sm-12">
                <component :is="'a'" @click="goRegistration()">
                  <card class="border-0 d-flex card-registration" hover shadow
                    body-classes="text-center align-items-center d-flex justify-content-center">
                    <object data="/img/svg/15-registration.svg" type="image/svg+xml"
                      class="text-white card-pajak"></object>
                    <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">{{
                      registration_label
                    }}
                    </h6>
                  </card>
                </component>
              </div>
              <div class="col-md-2 col-sm-12">
                <component :is="'a'" @click="logout">
                  <card class="border-0 d-flex card-registration" hover shadow
                    body-classes="text-center align-items-center d-flex justify-content-center">
                    <object type="image" class="text-white card-pajak">
                      <i class="fa fa-sign-out  mr-2" style="font-size: 100px"></i>
                    </object>
                    <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Log Out
                    </h6>
                  </card>
                </component>
              </div>
            </template>
            <template v-else>
              <div class="col-md-2 col-sm-12">
                <component :is="'a'" @click="goProfilePage()">
                  <card class="border-0 d-flex card-registration2" hover shadow
                    body-classes="text-center align-items-center d-flex justify-content-center">
                    <object type="image" class="text-white card-pajak">
                      <i class="fa fa-user  mr-2" style="font-size: 100px"></i>
                    </object>
                    <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">
                      {{ $store.state.auth.user.name }}
                    </h6>
                  </card>
                </component>
              </div>
              <div class="col-md-2 col-sm-12">
                <component :is="'a'" @click="goObjekPajak()">
                  <card class="border-0 d-flex card-air-tanah" hover shadow
                    body-classes="text-center align-items-center d-flex justify-content-center">
                    <object type="image" class="text-white card-pajak">
                      <i class="fa fa-briefcase mr-2" style="font-size: 100px"></i>
                    </object>
                    <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">
                      Objek Pajak (NPWPD)
                    </h6>
                  </card>
                </component>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="col-md-2 col-sm-12">
              <component :is="'a'" @click="goRegistrationEmail()">
                <card class="border-0 d-flex card-registration2" hover shadow
                  body-classes="text-center align-items-center d-flex justify-content-center">
                  <object type="image" class="text-white card-pajak">
                    <i class="fa fa-envelope  mr-2" style="font-size: 100px"></i>
                  </object>
                  <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Registrasi Akun
                  </h6>
                </card>
              </component>
            </div>
          </template>

          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="$router.push('/pajak-barang-dan-jasa-tertentu')">
              <card class="border-0 d-flex card-hotel" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object data="/img/svg/4-Hotel.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Pajak Barang dan Jasa
                  Tertentu</h6>
              </card>
            </component>
          </div>

          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="$router.push('/pelaporan-pajak')">
              <card class="border-0 d-flex card-walet" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object type="image" class="text-white card-pajak">
                  <i class="fa fa-print mr-2" style="font-size: 100px"></i>
                </object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">Pelaporan Pajak</h6>
              </card>
            </component>
          </div>
        </div>
        <div class="row">

          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="goPbb()">
              <card class="border-0 d-flex card-pbb" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object data="/img/svg/8-PBB-B2.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">PBB-P2</h6>
              </card>
            </component>
          </div>

          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="goAirTanah()">
              <card class="border-0 d-flex card-air-tanah" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object data="/img/svg/2-Pajak Air Tanah.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">PAJAK AIR TANAH</h6>
              </card>
            </component>
          </div>

          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="goBphtb()">
              <card class="border-0 d-flex card-bphtb" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object data="/img/svg/10-BPHTB.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">BPHTB</h6>
              </card>
            </component>
          </div>
          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="goWalet()">
              <card class="border-0 d-flex card-walet" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object data="/img/svg/11-wallet.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">PAJAK SARANG BURUNG
                  WALET</h6>
              </card>
            </component>
          </div>

          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="goMblb()">
              <card class="border-0 d-flex card-mnlb" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object data="/img/svg/12-MBLB.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">PAJAK MBLB</h6>
              </card>
            </component>
          </div>
          
          <div class="col-md-2 col-sm-12">
            <component :is="'a'" @click="goReklame()">
              <card class="border-0 d-flex card-reklame" hover shadow
                body-classes="text-center align-items-center d-flex justify-content-center">
                <object data="/img/svg/7-Pajak Reklame.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">PAJAK REKLAME</h6>
              </card>
            </component>
          </div>
        </div>
      </div>
    </div>
    <modal-informasi-pajak ref="modal-informasi-pajak" title="Pencarian Informasi Database Pajak" code="0"
      url="/api/v1/pajak-daerah"></modal-informasi-pajak>

    <registration ref="modal-registration" title="Registrasi Subjek Pajak" code="1"></registration>
    <register-email ref="modal-register-email" title="Registrasi User" code="1"></register-email>
    <register-user ref="modal-password" :isNpwpd="isHasNpwpd"></register-user>
  </div>
</template>
<style scoped></style>
<script>
import ModalInformasiPajak from "./GlobalPage/InformasiPajak";
import Registration from "./GlobalPage/Regstration.vue";
import Database from "./GlobalPage/Database.vue";
import RegisterEmail from "./GlobalPage/RegisterEmail.vue";
import RegisterUser from "@/views/GlobalPage/RegisterUser";
export default {
  name: "home",
  components: {
    ModalInformasiPajak, Registration, Database,
    RegisterUser, RegisterEmail
  },
  computed: {
    isLogin() {
      return this.$store.state.auth.status.loggedIn;
    },
    isHasNpwpd() {
      return this.$store.state.auth.status.loggedIn ? this.$store.state.auth.user.npwpd ? true : false : false;
    },
    registration_label() {
      return this.$store.state.auth.status.loggedIn
        ? this.$store.state.auth.user.npwpd
        : "REGISTRASI NPWPD";
    },
  },
  methods: {
    changePassword() {
      this.$refs["modal-password"].showModal();
    },
    goPbb() {
      this.$router.push("/pbb");
    },
    goBphtb() {
      this.$router.push("/bphtb");
    },
    goHotel() {
      this.$router.push("/hotel");
    },
    goHiburan() {
      this.$router.push("/hiburan");
    },
    goRestoran() {
      this.$router.push("/restoran");
    },
    goReklame() {
      this.$router.push("/reklame");
    },
    goWalet() {
      this.$router.push("/burung-walet");
    },
    goAirTanah() {
      this.$router.push("/air-tanah");
    },
    goMblb() {
      this.$router.push("/mineral-bukan-logam-batuan");
    },
    goPjj() {
      this.$router.push("/pajak-penerangan-jalan");
    },
    goParking() {
      this.$router.push("/parking");
    },
    goSOP() {
      this.$router.push("/sop");
    },
    goSIPP() {
      this.$router.push("/sipp");
    },
    goRegistration() {
      this.$refs["modal-registration"].showModal();
      if (this.isLogin) {
        this.$refs["modal-registration"].updateMode(
          this.$store.state.auth.user
        );
      }
    },
    goRegistrationEmail() {
      this.$router.push("/register");
    },
    goProfilePage() {
      this.$router.push("/update-profile");
    },
    goObjekPajak() {
      this.$router.push("/objek-pajak/list-npwpd");
    },
    async logout() {
      await this.$store.dispatch("auth/logout");
      this.$router.push("/landing");
    },
  },
};
</script>
